import React from 'react';
import Icon from './Icon';
import './IconsGrid.css';

const IconsGrid = () => {
  return (
    <section id="About" className="features-icons bg-light text-center">
      <div className="container">
        <div className="row">
          <Icon title="Capture" description="Capture body-movement in AR" icon="fa-video" />
          <Icon title="Replay" description="Replay motion-capture in AR" icon="fa-running" />
          <Icon title="Export" description="Export to any platform" icon="fa-upload" />
        </div>
      </div>
    </section>
  );
};

export default IconsGrid;
